import { nameOf } from '../../../app/shared/common';
import { QueryParser } from '../../../app/shared/QueryParser';

export class PricelistsQuery {
  tab?: string;
}

export const TAB = nameOf<PricelistsQuery>('tab');

export class PricelistsQueryParser extends QueryParser {
  public static toModel(query: Map<string, string>): PricelistsQuery {
    const queryModel = new PricelistsQuery();

    queryModel.tab = QueryParser.getValue(query, TAB);

    return queryModel;
  }

  public static toQuery(queryModel: PricelistsQuery): Map<string, string> {
    const query = new Map<string, string>();

    QueryParser.setValue(query, TAB, queryModel.tab);

    return query;
  }
}
